"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryCollectImportsDeep = exports.parsePseudoImportNamed = exports.parsePseudoImport = exports.parseStImport = exports.parseModuleImportStatement = exports.ensureModuleImport = exports.createAtImportProps = exports.ensureImportsMessages = exports.parseImportMessages = void 0;
const path_1 = __importDefault(require("path"));
const imports_parser_1 = require("@tokey/imports-parser");
const diagnostics_1 = require("../diagnostics");
const postcss_1 = require("postcss");
const string_1 = require("../helpers/string");
const selector_1 = require("./selector");
const postcss_value_parser_1 = __importDefault(require("postcss-value-parser"));
exports.parseImportMessages = {
    ST_IMPORT_STAR() {
        return '@st-import * is not supported';
    },
    INVALID_ST_IMPORT_FORMAT(errors) {
        return `Invalid @st-import format:\n - ${errors.join('\n - ')}`;
    },
    ST_IMPORT_EMPTY_FROM() {
        return '@st-import must specify a valid "from" string value';
    },
    EMPTY_IMPORT_FROM() {
        return '"-st-from" cannot be empty';
    },
    MULTIPLE_FROM_IN_IMPORT() {
        return `cannot define multiple "-st-from" declarations in a single import`;
    },
    DEFAULT_IMPORT_IS_LOWER_CASE() {
        return 'Default import of a Stylable stylesheet must start with an upper-case letter';
    },
    ILLEGAL_PROP_IN_IMPORT(propName) {
        return `"${propName}" css attribute cannot be used inside :import block`;
    },
    FROM_PROP_MISSING_IN_IMPORT() {
        return `"-st-from" is missing in :import block`;
    },
    INVALID_NAMED_IMPORT_AS(name) {
        return `Invalid named import "as" with name "${name}"`;
    },
    INVALID_NESTED_TYPED_IMPORT(type, name) {
        return `Invalid nested ${type} import "${name}"`;
    },
};
exports.ensureImportsMessages = {
    ATTEMPT_OVERRIDE_SYMBOL(kind, origin, override) {
        return `Attempt to override existing ${kind} import symbol. ${origin} -> ${override}`;
    },
    PATCH_CONTAINS_NEW_IMPORT_IN_NEW_IMPORT_NONE_MODE() {
        return `Attempt to insert new a import in newImport "none" mode`;
    },
};
function createAtImportProps(importObj) {
    const named = Object.entries(importObj.named || {});
    const keyframes = Object.entries(importObj.keyframes || {});
    let params = '';
    if (importObj.defaultExport) {
        params += importObj.defaultExport;
    }
    if (importObj.defaultExport && (named.length || keyframes.length)) {
        params += ', ';
    }
    if (named.length || keyframes.length) {
        params += '[';
        const namedParts = getNamedImportParts(named);
        const keyFramesParts = getNamedImportParts(keyframes);
        params += namedParts.join(', ');
        if (keyFramesParts.length) {
            if (namedParts.length) {
                params += ', ';
            }
            params += `keyframes(${keyFramesParts.join(', ')})`;
        }
        params += ']';
    }
    params += ` from ${JSON.stringify(importObj.request || '')}`;
    return { name: 'st-import', params };
}
exports.createAtImportProps = createAtImportProps;
function ensureModuleImport(ast, importPatches, options, diagnostics = new diagnostics_1.Diagnostics()) {
    const patches = createImportPatches(ast, importPatches, options, diagnostics);
    if (!diagnostics.reports.length) {
        for (const patch of patches) {
            patch();
        }
    }
    return { diagnostics };
}
exports.ensureModuleImport = ensureModuleImport;
function createImportPatches(ast, importPatches, { newImport }, diagnostics) {
    const patches = [];
    const handled = new Set();
    for (const node of ast.nodes) {
        if (node.type === 'atrule' && node.name === 'st-import') {
            const imported = parseStImport(node, '*', diagnostics);
            processImports(imported, importPatches, handled, diagnostics);
            patches.push(() => node.assign(createAtImportProps(imported)));
        }
        else if (node.type === 'rule' && node.selector === ':import') {
            const imported = parsePseudoImport(node, '*', diagnostics);
            processImports(imported, importPatches, handled, diagnostics);
            patches.push(() => {
                const named = generateNamedValue(imported);
                const { defaultDecls, namedDecls } = patchDecls(node, named, imported);
                if (imported.defaultExport) {
                    ensureSingleDecl(defaultDecls, node, '-st-default', imported.defaultExport);
                }
                if (named.length) {
                    ensureSingleDecl(namedDecls, node, '-st-named', named.join(', '));
                }
            });
        }
    }
    if (newImport === 'none') {
        if (handled.size !== importPatches.length) {
            diagnostics.error(ast, exports.ensureImportsMessages.PATCH_CONTAINS_NEW_IMPORT_IN_NEW_IMPORT_NONE_MODE());
        }
        return patches;
    }
    if (handled.size === importPatches.length) {
        return patches;
    }
    for (const item of importPatches) {
        if (handled.has(item)) {
            continue;
        }
        if (!hasDefinitions(item)) {
            continue;
        }
        if (newImport === 'st-import') {
            patches.push(() => {
                ast.prepend((0, postcss_1.atRule)(createAtImportProps({
                    defaultExport: item.defaultExport || '',
                    keyframes: item.keyframes || {},
                    named: item.named || {},
                    request: item.request,
                })));
            });
        }
        else {
            patches.push(() => {
                ast.prepend((0, postcss_1.rule)(createPseudoImportProps(item)));
            });
        }
    }
    return patches;
}
function setImportObjectFrom(importPath, dirPath, importObj) {
    if (!path_1.default.isAbsolute(importPath) && !importPath.startsWith('.')) {
        importObj.request = importPath;
        importObj.from = importPath;
    }
    else {
        importObj.request = importPath;
        importObj.from =
            path_1.default.posix && path_1.default.posix.isAbsolute(dirPath) // browser has no posix methods
                ? path_1.default.posix.resolve(dirPath, importPath)
                : path_1.default.resolve(dirPath, importPath);
    }
}
function parseModuleImportStatement(node, context, diagnostics) {
    if (node.type === 'atrule') {
        return parseStImport(node, context, diagnostics);
    }
    else {
        return parsePseudoImport(node, context, diagnostics);
    }
}
exports.parseModuleImportStatement = parseModuleImportStatement;
function parseStImport(atRule, context, diagnostics) {
    var _a, _b;
    var _c;
    const keyframes = {};
    const importObj = {
        defaultExport: '',
        from: '',
        request: '',
        named: {},
        rule: atRule,
        context,
        keyframes,
        typed: {
            keyframes,
        },
    };
    const imports = (0, imports_parser_1.parseImports)(`import ${atRule.params}`, '[', ']', true)[0];
    if (imports && imports.star) {
        diagnostics.error(atRule, exports.parseImportMessages.ST_IMPORT_STAR());
    }
    else {
        setImportObjectFrom(imports.from || '', context, importObj);
        importObj.defaultExport = imports.defaultName || '';
        if (importObj.defaultExport &&
            !(0, selector_1.isCompRoot)(importObj.defaultExport) &&
            importObj.from.endsWith(`.css`)) {
            diagnostics.warn(atRule, exports.parseImportMessages.DEFAULT_IMPORT_IS_LOWER_CASE(), {
                word: importObj.defaultExport,
            });
        }
        if (imports.tagged) {
            for (const [kind, namedTyped] of Object.entries(imports.tagged)) {
                for (const [impName, impAsName] of Object.entries(namedTyped)) {
                    (_a = (_c = importObj.typed)[kind]) !== null && _a !== void 0 ? _a : (_c[kind] = {});
                    importObj.typed[kind][impAsName] = impName;
                }
            }
        }
        if (imports.named) {
            for (const [impName, impAsName] of Object.entries(imports.named)) {
                importObj.named[impAsName] = impName;
            }
        }
        if (imports.errors.length) {
            diagnostics.error(atRule, exports.parseImportMessages.INVALID_ST_IMPORT_FORMAT(imports.errors));
        }
        else if (!((_b = imports.from) === null || _b === void 0 ? void 0 : _b.trim())) {
            diagnostics.error(atRule, exports.parseImportMessages.ST_IMPORT_EMPTY_FROM());
        }
    }
    return importObj;
}
exports.parseStImport = parseStImport;
function parsePseudoImport(rule, context, diagnostics) {
    let fromExists = false;
    const keyframes = {};
    const importObj = {
        defaultExport: '',
        from: '',
        request: '',
        named: {},
        keyframes,
        typed: {
            keyframes,
        },
        rule,
        context,
    };
    rule.walkDecls((decl) => {
        switch (decl.prop) {
            case `-st-from`: {
                const importPath = (0, string_1.stripQuotation)(decl.value);
                if (!importPath.trim()) {
                    diagnostics.error(decl, exports.parseImportMessages.EMPTY_IMPORT_FROM());
                }
                if (fromExists) {
                    diagnostics.warn(rule, exports.parseImportMessages.MULTIPLE_FROM_IN_IMPORT());
                }
                setImportObjectFrom(importPath, context, importObj);
                fromExists = true;
                break;
            }
            case `-st-default`:
                importObj.defaultExport = decl.value;
                if (!(0, selector_1.isCompRoot)(importObj.defaultExport) && importObj.from.endsWith(`.css`)) {
                    diagnostics.warn(decl, exports.parseImportMessages.DEFAULT_IMPORT_IS_LOWER_CASE(), {
                        word: importObj.defaultExport,
                    });
                }
                break;
            case `-st-named`:
                {
                    const { typedMap, namedMap } = parsePseudoImportNamed(decl.value, decl, diagnostics);
                    importObj.named = namedMap;
                    importObj.keyframes = typedMap.keyframes || {};
                    importObj.typed = typedMap;
                }
                break;
            default:
                diagnostics.warn(decl, exports.parseImportMessages.ILLEGAL_PROP_IN_IMPORT(decl.prop), {
                    word: decl.prop,
                });
                break;
        }
    });
    if (!importObj.from) {
        diagnostics.error(rule, exports.parseImportMessages.FROM_PROP_MISSING_IN_IMPORT());
    }
    return importObj;
}
exports.parsePseudoImport = parsePseudoImport;
function parsePseudoImportNamed(value, node, diagnostics) {
    const namedMap = {};
    const typedMap = {};
    if (value) {
        handleNamedTokens((0, postcss_value_parser_1.default)(value), namedMap, typedMap, node, diagnostics);
    }
    return { namedMap, typedMap };
}
exports.parsePseudoImportNamed = parsePseudoImportNamed;
function createPseudoImportProps(item) {
    const nodes = [];
    const named = generateNamedValue(item);
    if (item.request) {
        nodes.push((0, postcss_1.decl)({ prop: '-st-from', value: JSON.stringify(item.request) }));
    }
    if (item.defaultExport) {
        nodes.push((0, postcss_1.decl)({
            prop: '-st-default',
            value: item.defaultExport,
        }));
    }
    if (named.length) {
        nodes.push((0, postcss_1.decl)({
            prop: '-st-named',
            value: named.join(', '),
        }));
    }
    return {
        selector: ':import',
        nodes,
    };
}
function patchDecls(node, named, pseudoImport) {
    const namedDecls = [];
    const defaultDecls = [];
    node.walkDecls((decl) => {
        if (decl.prop === '-st-named') {
            decl.assign({ value: named.join(', ') });
            namedDecls.push(decl);
        }
        else if (decl.prop === '-st-default') {
            decl.assign({ value: pseudoImport.defaultExport });
            defaultDecls.push(decl);
        }
    });
    return { defaultDecls, namedDecls };
}
function ensureSingleDecl(decls, node, prop, value) {
    if (!decls.length) {
        node.append((0, postcss_1.decl)({ prop, value }));
    }
    else if (decls.length > 1) {
        // remove duplicates keep last one
        for (let i = 0; i < decls.length - 1; i++) {
            decls[i].remove();
        }
    }
}
function getNamedImportParts(named) {
    const parts = [];
    for (const [as, name] of named) {
        if (as === name) {
            parts.push(name);
        }
        else {
            parts.push(`${name} as ${as}`);
        }
    }
    return parts;
}
function generateNamedValue({ named = {}, keyframes = {}, }) {
    const namedParts = getNamedImportParts(Object.entries(named));
    const keyframesParts = getNamedImportParts(Object.entries(keyframes));
    if (keyframesParts.length) {
        namedParts.push(`keyframes(${keyframesParts.join(', ')})`);
    }
    return namedParts;
}
function hasDefinitions({ named = {}, keyframes = {}, defaultExport, }) {
    return defaultExport || Object.keys(named).length || Object.keys(keyframes).length;
}
function processImports(imported, importPatches, handled, diagnostics) {
    const ops = ['named', 'keyframes'];
    for (const patch of importPatches) {
        if (handled.has(patch)) {
            continue;
        }
        if (imported.request === patch.request) {
            for (const op of ops) {
                const patchBucket = patch[op];
                if (!patchBucket) {
                    continue;
                }
                for (const [asName, symbol] of Object.entries(patchBucket)) {
                    const currentSymbol = imported[op][asName];
                    if (currentSymbol === symbol) {
                        continue;
                    }
                    else if (currentSymbol) {
                        diagnostics.error(imported.rule, exports.ensureImportsMessages.ATTEMPT_OVERRIDE_SYMBOL(op, currentSymbol === asName
                            ? currentSymbol
                            : `${currentSymbol} as ${asName}`, symbol === asName ? symbol : `${symbol} as ${asName}`));
                    }
                    else {
                        imported[op][asName] = symbol;
                    }
                }
            }
            if (patch.defaultExport) {
                if (!imported.defaultExport) {
                    imported.defaultExport = patch.defaultExport;
                }
                else if (imported.defaultExport !== patch.defaultExport) {
                    diagnostics.error(imported.rule, exports.ensureImportsMessages.ATTEMPT_OVERRIDE_SYMBOL('default', imported.defaultExport, patch.defaultExport));
                }
            }
            handled.add(patch);
        }
    }
}
function handleNamedTokens(tokens, mainBucket, typedBuckets, node, diagnostics) {
    var _a;
    var _b;
    const { nodes } = tokens;
    for (let i = 0; i < nodes.length; i++) {
        const token = nodes[i];
        if (token.type === 'word') {
            const space = nodes[i + 1];
            const as = nodes[i + 2];
            const spaceAfter = nodes[i + 3];
            const asName = nodes[i + 4];
            if (isImportAs(space, as)) {
                if ((spaceAfter === null || spaceAfter === void 0 ? void 0 : spaceAfter.type) === 'space' && (asName === null || asName === void 0 ? void 0 : asName.type) === 'word') {
                    mainBucket[asName.value] = token.value;
                    i += 4; //ignore next 4 tokens
                }
                else {
                    i += !asName ? 3 : 2;
                    diagnostics.warn(node, exports.parseImportMessages.INVALID_NAMED_IMPORT_AS(token.value));
                    continue;
                }
            }
            else {
                mainBucket[token.value] = token.value;
            }
        }
        else if (token.type === 'function') {
            if (!typedBuckets) {
                diagnostics.warn(node, exports.parseImportMessages.INVALID_NESTED_TYPED_IMPORT(token.value, postcss_value_parser_1.default.stringify(token)));
            }
            else {
                (_a = typedBuckets[_b = token.value]) !== null && _a !== void 0 ? _a : (typedBuckets[_b] = {});
                handleNamedTokens(token, typedBuckets[token.value], null, node, diagnostics);
            }
        }
    }
}
function isImportAs(space, as) {
    return (space === null || space === void 0 ? void 0 : space.type) === 'space' && (as === null || as === void 0 ? void 0 : as.type) === 'word' && (as === null || as === void 0 ? void 0 : as.value) === 'as';
}
function tryCollectImportsDeep(stylable, meta, imports = new Set()) {
    for (const { context, request } of meta.getImportStatements()) {
        try {
            const resolved = stylable.resolver.resolvePath(context, request);
            if (!imports.has(resolved)) {
                imports.add(resolved);
                tryCollectImportsDeep(stylable, stylable.analyze(resolved), imports);
            }
        }
        catch (e) {
            /** */
        }
    }
    return imports;
}
exports.tryCollectImportsDeep = tryCollectImportsDeep;
//# sourceMappingURL=import.js.map